import React, { useState, useEffect, useContext } from "react";
import { styled } from '@mui/material/styles';
import { API } from 'aws-amplify';

import { useNavigate } from 'react-router-dom';

import { ProfielContext } from "../../context/profiel-context";
import { BoerderyContext } from "../../context/boerdery-context";

import { Alert, AlertTitle } from "@mui/material";
import Loader from '../../components/Loader/Loader';
import clsx from 'clsx';
import { getResponseData } from "../../utils/apiHelpers";
import { getApiErrorResponse } from "../../utils/apiErrorHandler";
const PREFIX = 'LandingPage';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },

  [`& .${classes.content}`]: {
    height: '100%'
  }
}));

const LandingPage = (props) => {

  const navigate = useNavigate();

  const profielContext = useContext(ProfielContext);
  const boerderyContext = useContext(BoerderyContext);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [gebruikerErrorMessage, setGebruikerErrorMessage] = useState("");

  const getUitnodigings = async () => {
    let apiName = "AWSApiGateway";
    let path = `/gebruikers/uitnodigings?gebruiker=${profielContext.profiel.epos
      },${profielContext.profiel.selfoon
        ? profielContext.profiel.selfoon.replace(/-|\+|\s/g, "")
        : ""
      }`;
    return await API.get(apiName, path, { response: true })
      .then((response) => {
        // console.log(response);
        if (response.status === 204) {
          return [];
        } else {
          return getResponseData(response, []);
        }
      })
      .catch((error) => {
        throw JSON.stringify(error.response);
      });
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (
        profielContext.profiel &&
        profielContext.profiel.naam &&
        boerderyContext.boerderye
      ) {
        const myPromises = () => Promise.all([getUitnodigings()]);
        myPromises()
          .then((results) => {
            // 0 boerderye  OF 1+ uitnodigings 1+ boerderye
            if (boerderyContext.boerderye.length < 1 || results[0].length > 0) {
              navigate("/landingpage");
            } else {
              // 0 uitnodigings 1+ boerderye
              navigate(`/profiel/${profielContext.profiel.gebruikernaam}/boodskappe`);
            }
          })
          .catch((error) => {
            let errordata = getApiErrorResponse(error);
            setGebruikerErrorMessage("Iets het skeefgeloop...");
            setErrorData({
              code: errordata.status,
              message: errordata.data.message,
            });
            setError(true);
            setLoading(false);
          });
      }
    }, 2000);
  }, [profielContext.profiel, boerderyContext.boerderye]);

  return (
    <Root className={clsx({
      [classes.root]: true
    })}>
      <main className={classes.content}>
        <div className="waitingpage">
          {loading ? (
            <div className="waitingloader">
              <Loader type="Grid" />
            </div>
          ) : error ? (
            <Alert severity="error">
              <AlertTitle>{gebruikerErrorMessage}</AlertTitle>
              {errorData.message} (Kode {errorData.code})
            </Alert>
          ) : null}
        </div>
      </main>
    </Root>
  );
};

export default (LandingPage);
